import { keycloakApi } from '@/integrations/keycloak/client';

/**
 * Reseta a senha de um usuário usando a API Keycloak
 * @param userId - ID numérico do usuário no Keycloak
 * @param newPassword - Nova senha a ser definida
 */
export async function resetUserPassword(userId: string | number, newPassword: string) {
  try {
    const userIdNumber = typeof userId === 'string' ? parseInt(userId, 10) : userId;
    
    if (isNaN(userIdNumber)) {
      throw new Error('ID do usuário inválido');
    }

    // Buscar o usuário primeiro para obter o generator_id (obrigatório no backend)
    const user = await keycloakApi.fetchUserById(userIdNumber);

    // Usar a API Keycloak para atualizar a senha
    // Incluir generator_id porque o backend exige esse campo
    await keycloakApi.updateUser(userIdNumber, {
      password: newPassword,
      generator_id: user.generator_id, // Backend exige generator_id ao atualizar
    });

    return { success: true };
  } catch (error) {
    throw error;
  }
}
